export const SET_ROLES = 'SET_ROLES';
export const SET_STATES = 'SET_STATES';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_STATUSES = 'SET_STATUSES';
